var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{style:(`
    font-size: var(--font-${_setup.props.fontSize});
    font-weight: var(--weight-${_setup.props.weight});
    color: var(--${_setup.props.color});
    line-height: ${_setup.getLineHeight};
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }